import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { Button, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import PasswordForm from 'shared/components/PasswordForm';
import { useAuth, useRequest } from 'shared/hooks';
import { updatePassword } from 'shared/api/admin';
import { VARIANTS } from 'shared/constants';
import { TextEditor } from 'shared/components/data-display/editors';

export default function PasswordUpdater() {
  const { user } = useAuth();
  const { request, isLoading } = useRequest();
  const [current, setCurrent] = useState('');
  const [open, setOpen] = useState(false);

  const setNewPassword = async (newPassword) => {
    const result = await request(updatePassword(user.id, current, newPassword));
    if (result) setOpen(false);
    return !!result;
  };

  return (
    <>
      <Button variant={VARIANTS.contained} onClick={() => setOpen(true)}>
        Update Password
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>
          Change Password
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,

            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <PasswordForm setNewPassword={setNewPassword} disabled={isLoading}>
            <TextEditor
              type="password"
              autoComplete="current-password"
              required
              setValue={(value) => setCurrent(value)}
              label="Current Password"
              value={current}
            />
          </PasswordForm>
        </DialogContent>
      </Dialog>
    </>
  );
}
